export default function getTimeZones(
    timeZones: string[],
    filter: (timeZones: string[]) => string[]
): string[] {
    if (filter && timeZones) {
        return filter(timeZones);
    } else if (timeZones && timeZones.length > 0) {
        return timeZones;
    } else {
        return [undefined];
    }
}
